// use-apply-auth.ts — Api suite, auth-binding hook
//
// Returns the imperative `applyAuth` callback that binds the current authenticated
// access token to outgoing requests. Intended ONLY for the auth suite (AuthProvider).
// Consolidates today's `useApiControl` into the api suite proper — the only thing
// that hook ever exposed in practice was `applyAuth`.

'use client';

import { useApiContext } from './ApiProvider';

export interface ApplyAuthInput {
  accessToken?: string;
}

export function useApplyAuth(): (input: ApplyAuthInput) => void {
  return useApiContext().applyAuth;
}
